<template>
    <v-container fluid>
        <v-row v-if="intBreakPoint > 2" align="center" class="bgcHomeRibus paddigMobile" style="padding: 15px 64px 0px">

        </v-row>
        <v-row class="paddigMobile" style="padding: 0px 64px 0px">
            <v-col cols="12" md="9" class="d-flex justify-center algin-center flex-column">
                <v-btn @click="goBack" style="max-width: 90px" class="d-flex justify-start pl-0" text color="#ff770fe0">
                    <v-icon>mdi-chevron-left</v-icon> Voltar
                </v-btn>
                <h2 class="textScope" style="font-weight: 400 !important; font-style: italic !important">
                    <!-- {{ imovelAluguel.parceiro }} -->

                </h2>
                <!-- <h1 class="titleScope titleMobile" style="color: #042d4c; font-size: 58px; font-weight: 600 !important">
                    TEste
                </h1> -->
                <p class="textScope"></p>
            </v-col>
            <v-col v-if="intBreakPoint < 2" cols="12" md="9" style="padding: 0px !important">
                <v-carousel hide-delimiter-background dark delimiter-icon="mdi-minus" height="290" light id="cases"
                    class="d-flex justify-center flex-column pt5 " :v-model="i">
                    <template v-slot:prev="{ on, attrs }">
                        <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-left</v-icon>
                    </template>
                    <template v-slot:next="{ on, attrs }">
                        <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-right</v-icon>
                    </template>

                    <v-carousel-item v-for="(img1, i) in fotos" :key="i">
                        <v-sheet tile style="background-color: transparent">
                            <v-row align="center">
                                <v-col cols="12" md="12">
                                    <!-- <img cover width="100%" :src="require(`@/assets/produtos/${img1}`)" /> -->
                                    <v-btn class="btnCarousel" @click="galeria = true" style="">
                                        Ver mais imagens</v-btn>
                                </v-col>
                            </v-row>
                        </v-sheet>
                    </v-carousel-item>
                </v-carousel>
                <h2 class="mt-1">dsadsadas</h2>
            </v-col>
            <v-col v-if="intBreakPoint > 2" cols="12" md="9">
                <v-sheet class="mx-auto">
                    <v-slide-group show-arrows>
                        <v-slide-item v-for="(img1, i) in fotos" :key="i" style="margin: 0 10px">
                            <a @click="galeriaDesk = true">
                                <!-- <v-img contain width="350" max-height="400" min-height="400"
                                    :src="require(`@/assets/produtos/${img1}`)">
                                    <template v-slot:placeholder>
                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                            <v-progress-circular indeterminate color="grey lighten-5">
                                            </v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img> -->
                            </a>
                        </v-slide-item>
                    </v-slide-group>
                </v-sheet>
            </v-col>

            <v-col cols="12" md="3" style="padding: 12px 0px !important">
                 <div class="borderGenerator segundoPadMob padTablet posicaoMobile"
                    style="padding: 10px 20px;  background-color: #fff; overflow-y: scroll; z-index: 999;">
                    <!-- */ {{ imovelAluguel.address.street }} */ -->
                    <h1 style="font-family: sofia pro; color: #000; font-size: 30px;">R$ 1.490,00 </h1>
                    <div style="margin-top: 10px">
                        <v-row>
                            <v-col cols="12" sm="12" class="d-flex align-center">
                                <v-icon style="margin-right: 10px">mdi-brightness-percent</v-icon>
                                <p style="font-family: sofia pro; margin-bottom: 0px !important;">até 45% em Ribtoken
                                </p>
                            </v-col>

                            <v-col cols="12" md="12" class="alinhadoM">
                                <v-btn
                                    style="background-color: #ff770fe0; margin-top: 10px; border-radius: 50px; color: #fff">
                                    Continuar com a reserva</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row class="paddigMobile" style="padding: 0px 64px 0px; margin-top: 50px">
            <v-col cols="12" md="9" style="padding-right: 50px !important">
                <h2 class="mt-3">Fritadeira Elétrica Sem Óleo Mondial Air Fryer Family NAF-03I 4 Litros Inox Preta -
                    110v</h2>

                <div style="padding: 0px 7px !important;" class="d-flex align-center">
                    <v-rating v-model="rating" color="yellow darken-3" background-color="grey darken-1"
                        empty-icon="$ratingFull" half-increments hover small>
                    </v-rating>
                    <span style="font-size: 14px; color: #8b8b8b;">(323)</span>
                </div>

               

                <h1 style="font-family: sofia pro; color: #00294b; font-weight: 500">
                    Descrição
                </h1>
                <p style="font-family: sofia pro">
                    Com capacidade de 4 litros, a Air Fryer Family da Mondial é perfeita para atender todas as suas
                    necessidades. O painel em aço inox também é um diferencial, oferecendo resistência e design moderno
                    para deixar a sua cozinha ainda mais bonita.

                    Você pode fritar seus alimentos preferidos com muita qualidade, sem usar óleo, sem fazer sujeira,
                    sem deixar fumaça pela casa. Com a Air Fryer Family, é rápido, fácil e saudável preparar qualquer
                    alimento. Pão de queijo, pastel, carnes, legumes, doces e outros pratos ficam prontos em minutos e
                    servem toda a sua fam...
                </p>
                <v-btn block style="background-color: transparent !important; box-shadow: none !important">Ver descrição
                </v-btn>
            </v-col>

            <v-col cols="12" md="9" style="padding: 12px 0px !important">
                <v-row style="margin-top: 10px">
                    <v-col cols="6" md="2"
                        style="min-width: 100px; border: 1px solid #cdcdcd; margin: 10px 10px; border-radius: 13px; justify-content: flex-start; padding: 15px 20px"
                        class="d-flex flex-column">
                        <h4 style="font-family: poppins; margin-top: 3px">
                            Cor
                        </h4>
                        <p class="textScope" style="margin-bottom: 0px; font-size: 15px;">Azul</p>
                    </v-col>

                    <v-col cols="6" md="2"
                        style="min-width: 100px; border: 1px solid #cdcdcd; margin: 10px 10px; border-radius: 13px; justify-content: flex-start; padding: 15px 20px"
                        class="d-flex flex-column">
                        <h4 style="font-family: poppins; margin-top: 3px">
                            Marca
                        </h4>
                        <p class="textScope" style="margin-bottom: 0px; font-size: 15px; line-height: 1;">Varias marcas
                        </p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>



        <v-dialog @keydown.right="i++" @keydown.left="--i" id="galeriaDesk" fullscreen overlay-color="#fff"
            v-model="galeriaDesk">

            <v-container style="background-color: #222222; width: 100vw; max-width: 100vw;">
                <v-row style="padding: 10px 60px">
                    <v-col cols="12" md="12" class="d-flex" style="display: flex; justify-content: end;">
                        <v-icon @click="galeriaDesk = false" style="color: #fff">
                            mdi-close
                        </v-icon>
                    </v-col>
                </v-row>
                <v-carousel hide-delimiter-background dark delimiter-icon="mdi-minus" id="cases"
                    class="d-flex justify-center flex-column pt5 " height="89.7vh" v-model="i">
                    <template v-slot:prev="{ on, attrs }">
                        <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-left</v-icon>
                    </template>
                    <template v-slot:next="{ on, attrs }">
                        <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-right</v-icon>
                    </template>

                    <v-carousel-item v-for="(fotos, i) in imovelAluguel.img" :key="i">
                        <v-row align="center">
                            <v-col cols="12" md="8" offset="2">
                                <v-img contain max-height="80vh" :src="require(`@/assets/${fotos}`)">
                                </v-img>
                            </v-col>
                        </v-row>
                    </v-carousel-item>
                </v-carousel>
            </v-container>
        </v-dialog>

        <v-dialog fullscreen overlay-color="#fff" style="background: #fff !important;" v-model="galeria">
            <v-container progress style="height: 100vh; background-color: #fff !important; padding: 0px !important;">
                <v-row style="background-color: #fff; padding: 10px 0px; height: 65px; " align="center">
                    <v-col cols="12" md="12"
                        style="box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.3) !important; padding: 11px 25px; z-index: 9;">
                        <v-icon style="color: #000" @click="galeria = false">mdi-arrow-left</v-icon>
                    </v-col>
                </v-row>
                <v-row style="background-color: #fff !important; padding: 0px; ">
                    <v-col style="padding: 4px !important;" class="alinhadoM" v-for="(fotos, i) in imovelAluguel.img"
                        :key="i" :cols="i in [1, 1] ? '8' : '4'">
                        <v-img @click="carouselGaleria = true" cover :src="require(`@/assets/${fotos}`)"></v-img>
                    </v-col>
                </v-row>
            </v-container>
        </v-dialog>

        <v-dialog fullscreen v-model="carouselGaleria">
            <v-row style="background-color: #fff; padding: 10px 0px; height: 65px; margin: 0px !important"
                align="center">
                <v-col cols="12" md="12"
                    style="box-shadow: 0px 4px 6px 0px rgba(0,0,0,0.3) !important; padding: 11px 25px; z-index: 9;">
                    <v-icon style="color: #000" @click="carouselGaleria = false">mdi-arrow-left</v-icon>
                </v-col>
            </v-row>
            <v-row justify="center" align="center" style="margin: 0px !important">
                <v-container style="height: 100vh; background-color: #8d8d8d; padding: 0px !important; justify-content: center;
    align-items: center;
    display: flex;">
                    <v-carousel hide-delimiter-background dark delimiter-icon="mdi-minus" id="cases"
                        class="d-flex justify-center flex-column pt5 " :v-model="i">
                        <template v-slot:prev="{ on, attrs }">
                            <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-left</v-icon>
                        </template>
                        <template v-slot:next="{ on, attrs }">
                            <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-right</v-icon>
                        </template>

                        <v-carousel-item v-for="(fotos, i) in imovelAluguel.img" :key="i">
                            <v-sheet tile style="background-color: transparent">
                                <v-row align="center">
                                    <v-col cols="12" md="12">
                                        <v-img contain width="100%" :src="require(`@/assets/${fotos}`)">
                                        </v-img>
                                    </v-col>
                                </v-row>
                            </v-sheet>
                        </v-carousel-item>
                    </v-carousel>
                </v-container>
            </v-row>
        </v-dialog>
        <v-dialog v-model="dialogInformacoes" width="550">
            <v-card>
                <v-card-title>{{ tituloDialog }}</v-card-title>
                <v-card-text class="text-h5  lighten-2">
                    {{ textoDialog }} </v-card-text>
            </v-card>

        </v-dialog>
    </v-container>
</template>

<style scoped>
@media (min-device-width: 300px) and (max-device-width: 819px) {
    .paddigMobile {
        padding: 0px 10px !important;
    }

    .posicaoMobile {
        position: initial !important;
        top: au
    }
}

.textScope {
    font-family: poppins;
}

.borderGenerator {
    /* box-shadow: 0px 1px 3px 3px rgb(0 0 0 / 35%); */
    border: 1px solid #bebebe;
}


.v-image {
    height: 100% !important;
}

.btnCarousel {
    color: rgb(255, 255, 255);
    border: 1px solid #ffffff;
    background-color: #ff770f2e !important;
    border-radius: 50px;
    box-shadow: none;
    position: absolute;
    bottom: 55px;
    right: 5px;
}
</style>

<script>
// import pagamento from "../components/pagamento.vue";
// import entrarContato from '../components/entrarContato.vue'

export default {

    data: () => ({
        dates: ['2019-09-10', '2019-09-20'],
        rating: 4.2,
        galeria: false,
        carouselGaleria: false,
        galeriaDesk: false,
        model1: 0,
        menu: false,
        model: null,
        imovelAluguel: { address: {}, infos: {} },
        fotos: [
            "produto1.webp", "produto2.webp", "produto3.webp", "produto4.webp", "produto1.webp", "produto2.webp", "produto3.webp", "produto4.webp",
        ],
        i: 0,
        dialogInformacoes: false,
        tituloDialog: "",
        textoDialog: "",
        infos: [
            `O valor do condomínio está sujeito a alteração conforme deliberações condominais. Além disso, ainda pode variar de acordo com as despesas fixas de consumo individual (ex. água), e eventuais do condomínio (ex.: água, luz, conservação e manutenção do prédio, taxas extras, entre outros).`,
            `O IPTU (Imposto Predial e Territorial Urbano) é um imposto municipal, cobrado das pessoas que possuem uma propriedade imobiliária urbana (como apartamento, sala comercial, casa ou outro tipo de imóvel dentro de uma região urbanizada) cujo valor é determinado pela prefeitura.`
        ],
        titulo: ['Condomínio', 'IPTU'],

    }),
    // components: { entrarContato },
    computed: {
        dateRangeText() {
            return this.dates.join(' ~ ')
        },
        intBreakPoint() {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return 0;
                case "sm":
                    return 1;
                case "md":
                    return 2;
                case "lg":
                    return 3;
                case "xl":
                    return 4;
                default:
                    return 0;
            }
        },
    },


    methods: {
        showDialog(index) {
            this.dialogInformacoes = true
            this.tituloDialog = this.titulo[index]
            this.textoDialog = this.infos[index]
        },
        goBack() {
            this.$router.go(-1);
        },
        openWhatsapp() {
            let mensagem = `Olá! Gostaria de mais informações sobre o ${this.imovelAluguel.titulo} anunciado no Marketplace!`
            window.open(`https://api.whatsapp.com/send/?phone=+5521974716499&text=${mensagem}&app_absent=0`, "_blank")
        }
    },

    mounted() {
        window.scrollTo(0, 0);
        if (this.$route.params.idAnuncio) {
            this.imovelAluguel = this.$store.getters.imovelAluguelById(this.$route.params.idAnuncio)
        }
    }
};
</script>

<style scope>
@media (min-device-width: 820px) and (max-device-width: 1200px) {
    .padTablet {
        padding: 20px !important;
    }
}

@media (min-device-width: 300px) and (max-device-width: 851px) {
    .padMobile {
        padding: 10px 10px !important;
    }

    .titleMobile {
        font-size: 45px !important;
        line-height: 1.2 !important;
    }

    .segundoPadMob {
        padding: 20px 0px;
    }
}
</style>
